exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s-box[data-v-bf199520]{-webkit-box-flex:1;-ms-flex:1;flex:1;background:#fff;height:28px;display:-webkit-box;display:-ms-flexbox;display:flex}img[data-v-bf199520]{display:block}", ""]);

// exports
